import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

const NotFoundPage = () => {
  const navigate = useNavigate()
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <Typography variant='h1' sx={{ fontWeight: 'bold', mb: 2 }}>
        404
      </Typography>
      <Typography variant='h6' sx={{ mb: 3 }}>
        Sorry, the page you're looking for doesn't exist.
      </Typography>
      <Button variant='contained' onClick={() => navigate('/')} size='large'>
        Go Home
      </Button>
    </Box>
  )
}
export default NotFoundPage
